module.exports = __webpack_public_path__ + "img/04.aaea6ede.jpg";